<template>
  <div class="elem-view-box">
    <div class="header-box">
      <div class="title-box">{{ elemName }}</div>
      <div
        class="screenshot-box"
        @click="openScreenShotDialog">
        <div class="icon-box">
          <icon-svg icon-class="ic-tianjiaxindesuolvetu" />
        </div>
        <div class="text">缩略图</div>
      </div>
    </div>
    <div class="engine-box">
      <div
        id="engineContainer"
        class="engine-container"
        ref="engineContainer"
        :style="`visibility:${canvasVisible ? 'visible' : 'hidden'}`" />
      <Loading
        v-if="showpercentage"
        :percentage="percentage" />
      <div
        class="attr-icon-box"
        v-if="!attributePanelVisible && canvasVisible"
        @click="openAttributePanel">
        <icon-svg
          class="icon"
          size="24"
          title="属性"
          icon-class="ic-shuxing1" />
      </div>
      <AttributePanel
        v-show="attributePanelVisible"
        :attributeData="attributeData"
        elemType="entity"
        :attrType="attrType"
        :attrTypeList="attrTypeList"
        :updateElementAttr="updateElementAttr"
        :closePanel="closeAttributePanel" />
      <ScreenShotDialog
        :visible="isScreenShotDialogVisible"
        :closeDialog="closeScreenShotDialog" />
    </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue'
import AttributePanel from './components/AttributePanel.vue'
import ScreenShotDialog from './components/ScreenShotDialog.vue'

import { isTemplateVersionConsistentWithEngine } from '@/utils/generalMethods'

import {
  getClientTokenService,
  publicElemViewModelService,
  privateElemViewModelService,
  getElemParamService,
  getElemParamTypeService
} from '@/service/interface'

export default {
  data() {
    return {
      isScreenShotDialogVisible: false,

      elemName: '',

      percentage: 0, // 进度条数值
      showpercentage: true, // 是否显示进度条
      canvasVisible: false,

      isStartLoadDataSet: false,

      attributePanelVisible: false,
      attributeData: [],
      attrType: '',
      attrTypeList: []
    }
  },
  components: {
    ScreenShotDialog,
    Loading,
    AttributePanel
  },
  mounted() {
    this.initClientInfo().then(() => {
      let { elemName } = this.$route.query
      this.elemName = elemName

      this.addEventListener()
    })
  },
  beforeDestroy() {
    this.unloadAllMainSce()
    this.removeEventListener()
    this.showpercentage = false

    window.removeEventListener('beforeunload', this.onBeforeUnload)
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    initClientInfo() {
      return new Promise(resolve => {
        if (window.isClientAuthByConfig) {
          this.initClientToken().then(() => {
            resolve()
          })
        } else {
          resolve()
        }
      })
    },
    initClientToken() {
      return new Promise(resolve => {
        let params = {
          clientId: window.clientId,
          secretKey: window.secretKey,
          userId: window.userId
        }
        getClientTokenService(params).then(result => {
          if (result.status === 200) {
            let response = result.data
            if (response.isSuccess) {
              sessionStorage.setItem('token', response.token)
              sessionStorage.setItem('tokenId', response.tokenId)
              resolve()
            } else {
              this.$message.error(response.errMsg)
            }
          }
        })
      })
    },
    addEventListener() {
      document.addEventListener('REDataSetLoadProgress', this.onLoadProgress)
      document.addEventListener('RESystemEngineCreated', this.onEngineCreated)
      document.addEventListener('REDataSetLoadFinish', this.onLoadFinish)
      document.addEventListener('RESystemSelElement', this.onSelElement)
      document.addEventListener('mousedown', this.onMouseDown)

      window.addEventListener('beforeunload', this.onBeforeUnload)
      window.addEventListener('resize', this.onResize)
    },
    removeEventListener() {
      document.removeEventListener('REDataSetLoadProgress', this.onLoadProgress)
      // prettier-ignore
      document.removeEventListener('RESystemEngineCreated', this.onEngineCreated)
      document.removeEventListener('REDataSetLoadFinish', this.onLoadFinish)
      document.removeEventListener('RESystemSelElement', this.onSelElement)
      document.removeEventListener('mousedown', this.onMouseDown)
    },
    initEngine() {
      window.BlackHole3D = window.BlackHole3D ? window.BlackHole3D : {}
      window.BlackHole3D.canvas = document.getElementById('engineCanvas')

      if (typeof window.BlackHole3D.RealBIMWeb === 'undefined') {
        window.BlackHole3D = window.CreateBlackHoleWebSDK(window.BlackHole3D)
      }
    },
    onEngineCreated() {
      const timer = setInterval(async () => {
        if (this.isEnginePreLoaded()) {
          clearInterval(timer)
          this.copyCanvas()

          this.isStartLoadDataSet = true

          const isVersionConsist = await isTemplateVersionConsistentWithEngine()
          const BlackHole3D = window.BlackHole3D
          if (!isVersionConsist) {
            const dataSetList = [
              {
                dataSetId: 'res_skybox',
                resourcesAddress: window.skyBoxUrl
              }
            ]
            BlackHole3D.Model.loadDataSet(dataSetList)

            BlackHole3D.Common.setMaxResMemMB(2000)
            BlackHole3D.Common.setExpectMaxInstMemMB(1900)
            BlackHole3D.Common.setExpectMaxInstDrawFaceNum(10000000)
            BlackHole3D.Common.setPageLoadLev(2)
            this.$message.error('请升级SDK版本至3.2.0.3247之后的版本')
            return
          }

          this.getDataSetList().then(dataSetList => {
            window.BlackHole3D.Model.loadDataSet(dataSetList)

            window.BlackHole3D.Common.setMaxResMemMB(2000)
            window.BlackHole3D.Common.setExpectMaxInstMemMB(1900)
            window.BlackHole3D.Common.setExpectMaxInstDrawFaceNum(10000000)
            window.BlackHole3D.Common.setPageLoadLev(2)
          })
        }
      }, 500)
    },
    getDataSetList() {
      return new Promise(resolve => {
        let { elemType, dataSetId } = this.$route.query
        let params = {
          dataSetIds: [dataSetId]
        }
        let dataSetList = []
        if (elemType === 'PublicElem') {
          publicElemViewModelService(params).then(response => {
            if (response.isSuccess) {
              let data = response.data
              data.forEach(item => {
                let obj = {
                  dataSetId: item.resId,
                  resourcesAddress: window.isMinIO
                    ? `${item.resourcesAddress}${item.resId}`
                    : item.resourcesAddress,
                  useTransInfo: true,
                  transInfo: [
                    item.scale.split(' ').map(Number),
                    item.rotate.split(' ').map(Number),
                    item.translation.split(' ').map(Number)
                  ]
                }
                dataSetList.push(obj)
              })
              resolve(dataSetList)
            }
          })
        } else {
          privateElemViewModelService(params).then(response => {
            if (response.isSuccess) {
              let data = response.data
              data.forEach(item => {
                let obj = {
                  dataSetId: item.resId,
                  resourcesAddress: window.isMinIO
                    ? `${item.resourcesAddress}${item.resId}`
                    : item.resourcesAddress,
                  useTransInfo: true,
                  transInfo: [
                    item.scale.split(' ').map(Number),
                    item.rotate.split(' ').map(Number),
                    item.translation.split(' ').map(Number)
                  ]
                }
                dataSetList.push(obj)
              })
              resolve(dataSetList)
            }
          })
        }
      })
    },
    onLoadFinish() {
      if (!this.isStartLoadDataSet) return

      this.canvasVisible = true
      this.showpercentage = false

      const BlackHole3D = window.BlackHole3D

      BlackHole3D.Graphics.setGeoCoordVisible(false)
      BlackHole3D.Graphics.setSysUIPanelVisible(false)

      let dataSetId = this.$route.query.dataSetId
      dataSetId = dataSetId.replaceAll('-', '')

      BlackHole3D.Entity.enterEditMode() //进入编辑模式
      let typeNames = window.BlackHole3D.Entity.getAllTypeNames(dataSetId) //获取所有的实例类型名称
      if (typeNames.length) {
        let entityList = []
        let entity = new BlackHole3D.REEntityInfo() //创建实例信息对象
        entity.dataSetId = dataSetId
        entity.entityType = typeNames[0]
        entityList.push(entity)
        BlackHole3D.Entity.addEntities(entityList) //添加实例对象
      }
      BlackHole3D.Entity.exitEditMode() //结束编辑模式
      let animPlayInfo = new BlackHole3D.REEntityAnimPlayInfo() //创建实例动画信息
      animPlayInfo.dataSetId = dataSetId
      animPlayInfo.entityType = typeNames[0]
      animPlayInfo.elemIdList = []
      animPlayInfo.animPlayMode = BlackHole3D.REEntityAnimPlayModeEm.REPEATTURN //动画的播放模式
      animPlayInfo.animPlayState = BlackHole3D.REEntityAnimPlayStateEm.PLAY //动画的播放状态
      BlackHole3D.Entity.setAnimPlayMode(animPlayInfo) //设置实体动画的播放信息

      // BlackHole3D.Probe.setElemsCanProbe(dataSetId, [], false)

      // 解决模型加载完成后，键盘WASD不能控制引擎相机移动的问题
      setTimeout(() => {
        window.BlackHole3D.canvas.focus()
      }, 500)
    },
    openScreenShotDialog() {
      this.isScreenShotDialogVisible = true
    },
    closeScreenShotDialog() {
      this.isScreenShotDialogVisible = false
    },
    openAttributePanel() {
      this.attributePanelVisible = true
      this.queryElementAttr()
    },
    closeAttributePanel() {
      this.attributePanelVisible = false
      this.attributeData = []
    },
    queryElementAttr() {
      let { elemType, dataSetId } = this.$route.query
      let dataSetType = elemType === 'PublicElem' ? 17 : 18
      let params = { dataSetType, dataSetId }
      getElemParamTypeService({ dataSetId, hostFileId: 1 }).then(response => {
        if (response.isSuccess) {
          let data = response.data
          if (data.length) {
            this.attrType = data[0].paramsType
            this.attrTypeList = data
          } else {
            this.attrType = 'default'
            this.attrTypeList = [{ paramsId: 'default', paramsType: '默认' }]
          }

          getElemParamService(params).then(res => {
            if (res.isSuccess) {
              this.attributeData = res.data
            } else {
              this.attributeData = []
              this.$message.error(res.errMsg)
            }
          })
        } else {
          let errMsg = response.errMsg
          if (!errMsg.includes('数据操作异常,表')) {
            this.$message.error(errMsg)
          }
        }
      })
    },
    updateElementAttr(attrType) {
      this.attrType = attrType
      let { elemType, dataSetId } = this.$route.query
      let dataSetType = elemType === 'PublicElem' ? 17 : 18
      let params = { dataSetType, dataSetId, paramType: attrType }
      getElemParamService(params).then(res => {
        if (res.isSuccess) {
          this.attributeData = res.data
        } else {
          this.attributeData = []
          this.$message.error(res.errMsg)
        }
      })
    },
    onLoadProgress(e) {
      if (!this.isStartLoadDataSet) return

      let percentage = e.detail.progress
      if (percentage < 10) {
        this.fromZeroFlag = true
      }
      if (percentage === 12 && this.fromZeroFlag) {
        percentage = 10
      }

      this.percentage = percentage
    },
    onBeforeUnload() {
      window.BlackHole3D.releaseEngine()
    },
    onResize() {
      this.setCanvasSize()
    },
    onSelElement() {
      window.BlackHole3D.BIM.delAllSelElems()
    },
    unloadAllMainSce() {
      window.BlackHole3D.Model.unloadAllDataSet()
    },
    onMouseDown(e) {
      // 按下鼠标中键时，禁用滚动
      if (e.button === 1) {
        e.preventDefault()
      }
    },
    setCanvasSize() {
      const domRef = this.$refs.engineContainer
      if (domRef) {
        window.BlackHole3D.m_re_em_window_width = domRef.clientWidth
        window.BlackHole3D.m_re_em_window_height = domRef.clientHeight
      }
    },
    copyCanvas() {
      const engineContainer = this.$refs.engineContainer
      const engineCanvas = document.getElementById('engineCanvas')
      engineContainer.append(engineCanvas)

      this.setCanvasSize()
    },
    isEnginePreLoaded() {
      let isPreLoaded = false
      const engineCanvas = document.getElementById('engineCanvas')
      const classList = engineCanvas.classList
      if (classList.contains('is-loaded')) {
        isPreLoaded = true
      }
      return isPreLoaded
    },
    isEngineCanvasExist() {
      let isExist = false
      const engineCanvas = document.getElementById('engineCanvas')
      if (engineCanvas) {
        isExist = true
      } else {
        isExist = false
      }
      return isExist
    },
    createEngineCanvas() {
      const engingCanvasDom = document.createElement('canvas')
      engingCanvasDom.id = 'engineCanvas'
      engingCanvasDom.classList.add('engine-canvas-box')
      // prettier-ignore
      engingCanvasDom.oncontextmenu = e => { e.preventDefault() }
      engingCanvasDom.tabIndex = '1'

      const engineContainer = document.getElementById('engineContainer')
      engineContainer.append(engingCanvasDom)
    }
  }
}
</script>

<style lang="less" scoped>
.elem-view-box {
  height: 100%;

  .header-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    padding: 0px 20px;
    background-color: var(--header-bg-color);
    box-shadow: var(--base-bg-dark-color30);

    .title-box {
      color: var(--project-header-title-color);
      font-size: 16px;
      font-weight: 400;
    }

    .screenshot-box {
      width: 64px;
      margin: auto 2px;
      padding: 6px 4px 4px 4px;
      border-radius: 8px;
      cursor: pointer;

      .icon-box {
        font-size: 20px;
        display: flex;
        justify-content: center;
        color: var(--eng-header-icon-color);
      }

      .text {
        font-size: 14px;
        margin-top: 4px;
        color: var(--eng-header-text-color);
      }

      &:hover {
        background: var(--eng-header-toolbar-hover-bgColor);
      }
    }
  }

  .engine-box {
    position: relative;
    height: calc(100% - 60px);
    background: var(--eng-loading-bgColor);

    .engine-container {
      height: 100%;
      :deep(.engine-canvas-box) {
        outline: none;
        &:focus {
          outline: none;
        }
      }
    }
  }

  .common-drag-panel {
    left: 20px;
    top: 20px;
  }

  .attr-icon-box {
    position: absolute;
    top: 20px;
    left: 20px;
    width: 40px;
    height: 40px;
    border-radius: 5px;
    background: #f5f4f8;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    .icon {
      display: block;
      text-align: center;
      font-size: 20px;
      color: #727d89;
    }
  }
}
</style>
